var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUiCirclePinkShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 124.951,
    height: 126.236,
    viewBox: "0 0 124.951 126.236",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI_Circle_pink_shadow",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1089",
    "data-name": "Tracciato 1089",
    d: "M0,.066l.687,101.32,39.844,9.926L78.352,90.287,97.338,48.742,83.523,0Z",
    transform: "translate(23.787 14.992) rotate(-2)",
    fill: "rgba(0,0,0,0.63)",
    opacity: 0.39
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1037",
    "data-name": "Tracciato 1037",
    d: "M34.108,0,1.184,30,0,74.171,16.62,109.149,58.878,118.9,99.99,100.594l21.942-41.1-18.009-50.3L55.322.274Z",
    transform: "translate(0 0)",
    fill: "#cd4d7a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiCirclePinkShadow);
export default __webpack_public_path__ + "static/media/UI_Circle_pink_shadow.33e44f70f8b46e733ab4488a9181fd32.svg";
export { ForwardRef as ReactComponent };